import { render, staticRenderFns } from "./CUDataTableActionColumn.vue?vue&type=template&id=0b41553d&scoped=true"
import script from "./CUDataTableActionColumn.vue?vue&type=script&lang=ts"
export * from "./CUDataTableActionColumn.vue?vue&type=script&lang=ts"
import style0 from "./CUDataTableActionColumn.vue?vue&type=style&index=0&id=0b41553d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b41553d",
  null
  
)

export default component.exports